// components/SearchBar.tsx
import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { SearchBarProps } from "./types";

export function SearchBar({
  label = "Search",
  value,
  onChange,
  onSearch,
  onClear,
  loading = false,
  placeholder = "",
  inputId = "search-input",
  className = "",
}: SearchBarProps) {
  return (
    <div className={`flex align-items-end gap-2 mb-3 ${className}`}>
      <span className="p-float-label">
        <InputText
          id={inputId}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-12rem"
          placeholder={placeholder}
        />
        <label htmlFor={inputId}>{label}</label>
      </span>
      <Button
        label="Buscar"
        icon="pi pi-search"
        onClick={onSearch}
        loading={loading}
      />
      <Button
        label="Limpiar"
        icon="pi pi-times"
        className="p-button-secondary"
        onClick={onClear}
      />
    </div>
  );
}
